module.exports = "/assets/c6ac52e3bf874b3e622717e1f6bc2e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZB.png
// module id = 2058
// module chunks = 0